import React, { Fragment, useState, useEffect, useRef } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux'

import mapboxgl from 'mapbox-gl';
// @ts-ignore
// import mapboxgl from '!mapbox-gl';

//import { Link, useLocation} from "react-router-dom";

import { SET_MAP} from '../state/uiActions';
import huLocale from './hu_locale'


const images =[
  //{url: 'https://movingobject.co/img/inactiveobject.png', id: 'inactiveobject'},
  //{url: 'https://movingobject.co/img/activeobject.png', id: 'activeobject'},
  {url: 'https://movingobject.co/img/1px-35B63F-08.png', id: '1pxmarker'},
  {url: ( ( typeof MARKER1 !== "undefined" ) ? MARKER1 : 'https://movingobject.co/img/logo-marker-32.png' ), id: 'marker1'  },
  {url: ( ( typeof MARKER2 !== "undefined" ) ? MARKER2 : 'https://movingobject.co/img/logo-marker-reddot-32.png' ), id: 'marker2'  } 
]

export default function MBMap(props)  {
  
  // console.log('rendering MBMap: ', map)
  
  // const [popups, setPopups] = useState({});

  const dispatch = useDispatch(); 
  //const map = useSelector((state) => state.ui.map) 
  const mapStyle = useSelector((state) => state.ui.mapStyle)
  //const mapStyleLoading = useSelector((state) => state.ui.mapStyleLoading)
  //const firstIdleTime = useSelector((state) => state.ui.firstIdleTime) 
  //const prevMapStyleRef = useRef(null)
  const firstMapLoadRef = useRef(true)
  const lastMapZoom = useRef(null)
  const lastMapCenter = useRef(null)

  useEffect(() => {
    // console.log('MBMap.useEffect mapStyle: ', mapStyle)
    //dispatch({ type: MAP_STYLE_LOADING, mapStyleLoading: true})

    // map.setStyle('mapbox://styles/mapbox/' + layerId);
    // mapbox://styles/mapbox/outdoors-v11
    // mapbox://styles/mapbox/satellite-v9 ->
    // mo-satellite:        mapbox://styles/sidlo/cjstib5du2l131fudebiiv8z8
    // mo-outdoors:         mapbox://styles/sidlo/cjsthd4085pqz1fs7zz7e9qek
    // mo-outdoors-minimal: mapbox://styles/sidlo/cktu0coif0kwn17o8nbfrusbm
    mapboxgl.accessToken='pk.eyJ1Ijoic2lkbG8iLCJhIjoiY2pzdGZ4dHF3MTZveTQ2cGFpZTUxN2R2dyJ9.A5SYpsq45relHrtJGnh2xA'
    
    var scrollZoom = true
    if ((typeof MAP_SCROLL_ZOOM !== "undefined") && (! MAP_SCROLL_ZOOM))  
      scrollZoom = false
    var newmap = new mapboxgl.Map({
      container: 'map', // container id
      style: mapStyle, // 'mapbox://styles/sidlo/cjsthd4085pqz1fs7zz7e9qek',  // ,
      //style: 'mapbox://styles/mapbox/streets-v11',
      center:  MAP_CENTER, // [19.801242, 47.884580],
      zoom: MAP_ZOOM, // MAP_ZOOM,
      attributionControl: false,
      logoControl: false,
      optimizeForTerrain: true, // TODO: config parameter
      scrollZoom: scrollZoom, 
      locale: huLocale,
    });
    if (lastMapZoom.current) newmap.setZoom(lastMapZoom.current)
    if (lastMapCenter.current) newmap.setCenter(lastMapCenter.current)
    

    // add attribution to an other location
    newmap.addControl(new mapboxgl.AttributionControl({compact: true}), 'bottom-left');
        
    // add navigation control
    newmap.addControl(new mapboxgl.NavigationControl());
        
    //if ((typeof MAP_SCALE_CONTROL !== "undefined") && (! MAP_SCALE_CONTROL)) {
      // scale control
      var scale = new mapboxgl.ScaleControl({
        maxWidth: 80,
        unit: 'metric'
      });
      newmap.addControl(scale);
    //}
        
    // fullscreen control
    newmap.addControl(new mapboxgl.FullscreenControl());
  
    // geolocation control 
    newmap.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: true
      })
    );
        
    newmap.once('load', function () { 
      // TODO: MAP_MINIMAL config might be useful (see keknap)
      // add images
      // https://github.com/mapbox/mapbox-gl-js/issues/4736      
      Promise.all(
        images.map(img => new Promise((resolve, reject) => {
          newmap.loadImage(img.url, function (error, res) {
              //console.log("addImage:", img.id )
              newmap.addImage(img.id, res)
              resolve();
          })
        }))  
      )
      .then( function() {
        newmap.on('styleimagemissing', function() {
          images.map(img => new Promise((resolve, reject) => {
            newmap.loadImage(img.url, function (error, res) {
              if (! newmap.hasImage(img.id)) {
                newmap.addImage(img.id, res)
                resolve();
              }
            })
          }))
        })
  
        // set language:
        //map.setLayoutProperty(//'country-label', 
        //                      'text-field', ['get', 'name_hu']);
        // when style is changed, all extra layers have to be added again 
        // (the new base stlye (terrain, satellite, ...) is clean): 
        //map.on('styledata', function() { // style.load
        //  // TODO: styledata is changed too frequently
        //  // console.log("map styledata event: ", map.getStyle().name);
        //  // dispatch({ type: MAP_STYLE_LOADED, style: mapStyle})
        //});
  
  
        // props.afterMapInitialization()
  
        // console.log("props.initialSubview: ", props.initialSubview)        
        // HACK: zoom to Hungary first if no subview is provided 
        if ( (! props.initialSubview) && (firstMapLoadRef.current) ) {
          newmap.fitBounds(new mapboxgl.LngLatBounds(
                        [ 22.906, 45.733], [16.106, 48.582], 
                        ), { padding: 40 } );
        }
        firstMapLoadRef.current = false 
        // TESTING: 
        //map.on('zoomend', function() {
        //  console.log("zoom level:", map.getZoom())
        //  console.log(map.getStyle().layers)
        //})
            
            
        //map.on('click', function (e) {
        //  //document.getElementById('info').innerHTML =
        //  //JSON.stringify(e.point) +
        //  // e.lngLat is the longitude, latitude geographical position of the event
        //  //JSON.stringify(e.lngLat.lng + ", " + e.lngLat.lat);
        //  //e.lngLat.lng + ", " + e.lngLat.lat
        //  alert(e.lngLat.lat + ', ' + e.lngLat.lng)
        //});
        // ---------------------------------------------
        //map.on('data', function(e) {
        //  console.log('data', e)
        //}.bind(this));
        //map.on('dataloading', function(e) {
        //  console.log('data', e)
        //}.bind(this));
        //map.on('styledata', function(e) {
        //  // console.log('MBMap: styledata', e)
        //}.bind(this));
        //map.on('sourcedata', function(e) {
        //  //console.log('MBMap: sourcedata', e)
        //  console.log(map.getStyle().sources)
        //}.bind(this));
        //map.on('sourcedataloading', function(e) {
        // console.log('sourcedataloading', e)
        //if (e.sourceId == this.geoJsonId) {
        //  console.log('sourcedata loaded', e)
        //}
        //console.log(map.getStyle().sources)
  
        // TODO: HACK: now moving all line layers to the top
        // map.moveLayer('routes');
        //}.bind(this));
        //        map.once('style.load', function(e) {
        //          console.log('map style.load', e)
        //          //if (e.sourceId == this.geoJsonId) {
        //          //  console.log('sourcedata loaded', e)
        //          //}
        //          //      if ((this.props.fitBounds)&&(! this.bbox) ){
        //        }.bind(this));

        newmap.setStyle(mapStyle)  
        newmap.once('styledata', function(e) {
            //dispatch({ type: MAP_FIRST_IDLE_TIME, firstIdleTime: new Date().toISOString()})
            // dispatch({ type: MAP_STYLE_LOADING, mapStyleLoading: false})
            // FIX: have to wait for both styledata and idle to be ready with the map
            newmap.once('idle', function(e) {
              dispatch({ type: SET_MAP, map: newmap})
            }.bind(this));
        }.bind(this));
        
      })
    })

    return () => {
      //console.log("MBMap.useEffect: remove") 
      lastMapZoom.current = newmap.getZoom()
      lastMapCenter.current = newmap.getCenter()
      
      if (newmap) newmap.remove()
      //dispatch({ type: MAP_STYLE_LOADING, mapStyleLoading: false})
    }
  }, [mapStyle]);


  // let query = new URLSearchParams(useLocation().search) ;
  // console.log('MBMapContainier:', query)
  //  query={query}

  return null ;
}
